<template>
    <div>
        <data-grid
            class="camp-calls-list"
            :url="url"
            :columns="columns"
            :title="title"
            ref="grid"
            :hideHeader="true"
            :hideActions="true"
            :selectionEnabled="false"
            :beforeSetupGrid="beforeSetupGrid"
            :perPage="10"
            :sortOptions="{
                enabled: true,
                field: 'date',
                type: 'desc',
            }"
            :expandedOptions="{
                enabled: true,
                template: 'camp-call-details',
            }"
        ></data-grid>
    </div>
</template>
<script>
import { formatPhoneNumber } from "../../utils/helpers.js";
import moment from "moment";

export default {
    props: {
        studentID: String,
    },
    data() {
        return {
            url: "",
            loading: true,
            ivrCalls: [],
            calls: [],
            pagination: {
                totalCount: 0,
                rowsPerPage: 5,
                page: 1,
            },

            title: "Calls",

            columns: [
                {
                    field: "phoneLine",
                    isIcon: true,
                    icon: (value) => {
                        if (!value) return "";

                        switch (value) {
                            case "PARENTS LINE":
                                return "mdi-phone-incoming";
                            case "STUDENTS LINE":
                                return "mdi-phone-outgoing";
                            default:
                                return "";
                        }
                    },
                    iconColor: (value) => {
                        if (!value) return "";

                        switch (value) {
                            case "PARENTS LINE":
                                return "#007827";
                            case "STUDENTS LINE":
                                return "#27a4d9";
                            default:
                                return "#aeb8bf";
                        }
                    },
                },
                {
                    sortable: true,
                    label: "Date",
                    field: "date",
                    type: "date",
                    dateOutputFormat: "MM/DD/YYYY h:mm:ss A",
                    hidden: false,
                    filterOptions: {
                        enabled: true,
                    },
                },
                {
                    sortable: false,
                    label: "Duration",
                    field: "duration",
                    hidden: false,
                    filterOptions: {
                        enabled: true,
                    },
                },
                {
                    sortable: true,
                    label: "From",
                    field: "from",
                    hidden: false,
                    filterOptions: {
                        enabled: true,
                    },
                },
                {
                    sortable: false,
                    label: "To",
                    field: "to",
                    hidden: false,
                    filterOptions: {
                        enabled: true,
                    },
                },
                {
                    sortable: false,
                    label: "Boot Number",
                    field: "bootNumber",
                    hidden: false,
                    filterOptions: {
                        enabled: true,
                    },
                },
                {
                    sortable: false,
                    label: "Phone Type",
                    field: "phoneType",
                    hidden: false,
                    filterOptions: {
                        enabled: true,
                    },
                },
                {
                    sortable: false,
                    label: "Phone Line",
                    field: "phoneLine",
                    hidden: false,
                    filterOptions: {
                        enabled: true,
                    },
                },
                {
                    sortable: false,
                    label: "Carrier",
                    field: "carrier",
                    hidden: false,
                    filterOptions: {
                        enabled: true,
                    },
                },
                {
                    sortable: false,
                    label: "Voicemail",
                    field: "voicemail",
                    type: "boolean",
                    formatFn: (value) => (value ? "Yes" : "No"),
                    hidden: false,
                    filterOptions: {
                        enabled: true,
                    },
                },
            ],
        };
    },
    async created() {
        // await this.loadIvrCalls();
    },
    watch: {
        studentID(newValue, oldValue) {
            // this.url = `campCalls?filter=(contains(tolower(studentID), '${
            //     this.newValue
            // }'))`;
        },
    },
    mounted() {},
    beforeDestroy() {},
    computed: {
        pages() {
            return this.pagination.rowsPerPage
                ? Math.ceil(this.ivrCalls.length / this.pagination.rowsPerPage)
                : 0;
        },
    },
    methods: {
        beforeSetupGrid() {
            this.url = "campCalls?studentID=" + this.studentID + "&branch=&to=";
        },
        getTotalCount() {
            if (this.$refs && this.$refs.grid) {
                return this.$refs.grid.pagination.totalCount;
            }

            return 0;
        },
        async loadIvrCalls() {
            const ivrCalls = await this.$http.get(
                "api/foodDistributionAccountInfo/getIvrCalls?accountID=" +
                    this.$route.params.id
            );
            this.loading = false;
            this.ivrCalls = ivrCalls.map((call) => {
                call.actions = [];
                call.showActions = false;

                return call;
            });
            this.calls = ivrCalls.slice(0, 5);
            this.pagination.totalCount = ivrCalls.length;
        },
        async openActions(call) {
            if (call.showActions) {
                call.showActions = false;
                return;
            }

            call.showActions = true;

            if (!call.actions.length) {
                const actions = await this.$http.get(
                    "api/broadcast/getCallActivity?callUUID=" + call.call_UUID
                );

                call.actions = actions.map((action) => {
                    action.date = moment(action.date).format("LTS");
                    action.title =
                        this.callActionsMap.get(action.eventType) ||
                        action.eventType;
                    action.description = this.getActionDescription(action);

                    return action;
                });
            }
        },
        getActionDescription(action) {
            if (
                [
                    "START_PAYMENT_PROCESS",
                    "START_AUTOPAYSETUP_PROCESS",
                ].includes(action.eventType)
            )
                return null;

            const inputActions = [
                "LOOKUP_PHONE",
                "VALIDATE_PHONE",
                "VALIDATE_PIN",
                "VALIDATE_CARD",
                "VALIDATE_EXP",
                "VALIDATE_SAVED_CARD",
            ];

            if (inputActions.includes(action.eventType)) {
                return action.inputDigits + " | " + action.response;
            }

            if (action.eventType == "CARD_PROCESSED_SUCCESS") {
                const pecies = action.response.split("|");
                const status = pecies
                    .find((p) => p.startsWith("status"))
                    .substring(7);
                const amount = pecies
                    .find((p) => p.startsWith("amount"))
                    .substring(7);

                return "$" + amount + " | " + status;
            }

            return action.response;
        },
        setPagianation() {
            if (this.getSkip() >= this.pagination.totalCount) return;

            const number =
                (this.pagination.page - 1) * this.pagination.rowsPerPage;

            this.calls = this.ivrCalls.slice(
                number,
                number + this.pagination.rowsPerPage
            );
        },
        formatPhoneNumber(number) {
            return formatPhoneNumber(number);
        },
        getSkip() {
            const page = this.pagination.page - 1;

            let skip = page * this.pagination.rowsPerPage;

            if (skip >= this.pagination.totalCount) {
                skip = this.pagination.totalCount - this.pagination.rowsPerPage;
            }

            return skip;
        },
        getCalls() {
            return this.ivrCalls;
        },
    },
};
</script>
<style>
.ivr-detail-text {
    font-size: 16px;
    font-weight: 400;
}
.camp-calls-list.container {
    padding-right: 0px !important;
    padding-left: 0px !important;
    padding-top: 40px !important;
}
</style>
